import React from 'react';
import SEO from '../components/SEO';
import Footer from '../components/Footer';
import { Mail, Phone, MapPin, Send } from 'lucide-react';
import './Contact.css';

const Contact = () => {
  return (
    <div className="contact-page">
      <SEO
        title="Contact Us"
        description="Get in touch with the FastInvoice team for support, sales, or general inquiries."
      />

      <section className="contact-hero">
        <div className="bg-glow glow-top-left"></div>
        <div className="contact-hero-content">
          <h1>Get in <span className="text-gradient">Touch</span></h1>
          <p>Have questions? We're here to help and would love to hear from you.</p>
        </div>
      </section>

      <section className="contact-content">
        <div className="contact-grid">

          <div className="contact-info">
            <h2>Contact Information</h2>
            <p className="info-desc">Reach out to us directly through any of these channels. We aim to respond within 24 hours.</p>

            <div className="info-cards">
              <div className="info-card">
                <div className="info-icon"><Mail size={24} /></div>
                <div>
                  <h4>Email Us</h4>
                  <p>support@fastinvoice.in</p>
                  {/* <p>sales@fastinvoice.in</p> */}
                </div>
              </div>
            </div>
          </div>

          <div className="contact-form-container">
            <h2>Send us a message</h2>
            <form className="contact-form" onSubmit={(e) => e.preventDefault()}>
              <div className="form-group">
                <label htmlFor="name">Full Name</label>
                <input type="text" id="name" placeholder="John Doe" required />
              </div>

              <div className="form-group">
                <label htmlFor="email">Email Address</label>
                <input type="email" id="email" placeholder="john@company.com" required />
              </div>

              <div className="form-group">
                <label htmlFor="subject">Subject</label>
                <select id="subject" required>
                  <option value="">Select a topic</option>
                  <option value="support">Technical Support</option>
                  {/* <option value="sales">Sales Inquiry</option> */}
                  <option value="billing">Billing Question</option>
                  <option value="other">Other</option>
                </select>
              </div>

              <div className="form-group">
                <label htmlFor="message">Message</label>
                <textarea id="message" rows="5" placeholder="How can we help you?" required></textarea>
              </div>

              <button type="submit" className="btn-submit">
                Send Message <Send size={18} />
              </button>
            </form>
          </div>

        </div>
      </section>

      <Footer />
    </div>
  );
};

export default Contact;
